/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { MatButtonModule } from '@angular/material/button';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Store } from '@ngxs/store';
import { ReportEditButtonComponent } from './report-edit-button.component';

@NgModule({
    imports: [ CommonModule, BrowserAnimationsModule, MatButtonModule, ReportEditButtonComponent ],
    providers: [ Store ]
})
export class ReportEditButtonModule {
    constructor(private injector: Injector) {
        const el = createCustomElement(ReportEditButtonComponent, {
            injector: this.injector
        });
        customElements.define('dash-gis-report-edit-button', el);
    }
}
